import app from 'flarum/forum/app';
import on from './gate';
import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
export default class LearnSongBox extends Component {
  view() {
    if (!on()) return null;
    const {
      song,
      ask
    } = this.attrs;
    return m("aside", {
      className: "Learn-songBox"
    }, song.image_url && m("img", {
      src: song.image_url,
      alt: "",
      loading: "lazy"
    }), m("div", {
      className: "Learn-songBox-copy"
    }, m("span", {
      className: "Learn-eyebrow"
    }, ask ? 'Keep learning' : 'From the Learn library'), m("h3", null, ask ? 'Learn page' : 'Learn page for ' + song.track), m("p", null, ask ? song.track + ' · ' + song.artist : song.artist + ' · Lessons, tabs and a practice plan')), m(Link, {
      className: "Button Button--primary",
      href: app.route('challenges.learn', {
        slug: song.slug
      })
    }, "Open Learn page ", m("span", {
      "aria-hidden": "true"
    }, "\u2192")));
  }
}